export const isConfluenceTitleToolbarSuggestTitle = ({
  configItem,
  lastTriggeredFrom
}) => {
  if (!configItem || !lastTriggeredFrom) {
    return false;
  }
  const configItemDefaultTitle = configItem.title({
    formatMessage: message => typeof message.defaultMessage === 'string' ? message.defaultMessage : ''
  });
  return configItemDefaultTitle === 'Suggest a title' && lastTriggeredFrom === 'confluenceTitleToolbar';
};